import axios from "axios";
import getApiBaseUrl from "helpers/getApiBaseUrl";
import { IPublicMenuQrResponse } from "adminPanel/menus/menusAPI";
import IStoreDto from "./IStoreDto";
import { IAutoComplete } from "adminPanel/dashboard/IAutoComplete";

export interface IEgyptStoreLinking {
  id: string;
  name: string;
  addressLabel: string | null;
  storeCode: string | null;
  isAddressValid: boolean;
  isCodeValid: boolean;
}

const baseUrl = getApiBaseUrl() + "store/";

function GetById(id: string) {
  return axios.get<IStoreDto>(baseUrl + `get-store/${id}`);
}

function Edit(storeDto: IStoreDto) {
  return axios.post<string>(baseUrl + `edit-store`, storeDto);
}

function Create(storeDto: IStoreDto) {
  return axios.post<string>(baseUrl + `create-store`, storeDto);
}

function GetStorePrinters(storeId: string) {
  return axios.get(baseUrl + `get-store-printers/${storeId}`);
}

function GetPublicStoreMenusQr(id: string) {
  return axios.get<IPublicMenuQrResponse>(baseUrl + `${id}/public-menus-qr`);
}

function GetStoreMenus(storeId: string) {
  return axios.get<IAutoComplete[]>(baseUrl + `get-store-menus/${storeId}`);
}

export interface IStoreItem {
  id: string;
  editId: string;
  name: string;
  categoryId: string;
  category: string;
  image: string | null;
  itemType: number;
  barcodes: string[];
}

function GetStoreItems(storeId: string) {
  return axios.get<IStoreItem[]>(baseUrl + `get-store-items/${storeId}`);
}

function GetEgyptStoreLinking() {
  return axios.get<IEgyptStoreLinking[]>(baseUrl + `get-egypt-store-linking`);
}

function CheckEgyptPosStoreValidity(posId: string) {
  return axios.get<boolean>(baseUrl + `check-egypt-pos-validity/${posId}`);
}

const storeAPI = {
  GetById,
  Edit,
  Create,
  GetStorePrinters,
  GetPublicStoreMenusQr,
  GetStoreMenus,
  GetStoreItems,
  GetEgyptStoreLinking,
  CheckEgyptPosStoreValidity,
};

export default storeAPI;
